import { Link } from "react-router-dom";
import styles from "./style/Music.module.css";
import Menu from "./menu.png";
import Music from "./image15.png";
import play from "./play.png";
import stop from "./stop.png";
import Aegleseeker from "./song/Aegleseeker.mp3";
import CHAOS from "./song/CHAOS.mp3";
import Dantalion from "./song/Dantalion.mp3";
import Igallta from "./song/Igallta.mp3";
import Liberation from "./song/Liberation.mp3";
import Marigold from "./song/Marigold.mp3";
import RingedGenesis from "./song/Ringed Genesis.mp3";
import 初音 from "./song/初音ミクの消失.mp3";
import 烈華 from "./song/烈華RESONANCE.mp3";
import 望影 from "./song/望影の方舟Six.mp3";

import { useEffect, useRef, useState } from "react";

function ChangeContent1() {
  let menu = document.getElementById("Menu");
  menu.style.height = "100vh";
}

function ChangeContent2() {
  let menu = document.getElementById("Menu");
  menu.style.height = "0";
}

function SongList(props) {
  const [timeplayed, setTimeplayed] = useState(0);
  const audioPlayer = useRef(null);
  const songtitle = useRef(null);
  const songauthor = useRef(null);
  const icon = [play, stop];

  useEffect(() => {
    if (audioPlayer && audioPlayer.current) {
      audioPlayer.current.addEventListener("timeupdate", (el) => {
        setTimeplayed(audioPlayer.current.currentTime);
        console.log(
          audioPlayer.current.currentTime / audioPlayer.current.duration
        );
      });
    }
  }, []);

  const handleSeek = (event) => {
    const seekTime = event.target.value;
    setTimeplayed(seekTime);
    audioPlayer.current.currentTime = seekTime;
  };

  function startOrStop() {
    if (audioPlayer.current.paused) {
      audioPlayer.current.play();
      songtitle.current.style.color = "#ff3eaf";
      songauthor.current.style.color = "#ff3eaf";
      icon.current.src = icon[1];
    } else {
      audioPlayer.current.pause();
      songtitle.current.style.color = "#fafafa";
      songauthor.current.style.color = "#fafafa";
      icon.current.src = icon[0];
    }
  }
  return (
    <div className={styles.songCard}>
      <div className={styles.songtitle} ref={songtitle}>
        {props.title}
      </div>
      <div className={styles.songauthor} ref={songauthor}>
        {props.artist}
      </div>
      <div className={styles.icon}>
        <img
          className={styles.buttonplay}
          src={play}
          ref={icon}
          onClick={startOrStop}
        />
        {/* <div className={styles.progressDiv}>
          <div className={styles.progress} id="totalProgress"></div>
          <div className={styles.progress} id="progressBar"></div>
        </div> */}
        <input
          type="range"
          min="0"
          max={audioPlayer.current ? audioPlayer.current.duration : 0}
          value={timeplayed}
          onChange={handleSeek}
        />
      </div>
      <audio ref={audioPlayer} src={props.song}></audio>
    </div>
  );
}

function Introduction() {
  return (
    <div className={styles.main}>
      <div className={styles.menu} id="Menu">
        <div className={styles.menutitle}>
          <Link to="/" className={styles.menutitletext}>
            <div>Rhythm with Game</div>
          </Link>
          <img
            src={Menu}
            className={styles.menuimg}
            id="icon"
            onClick={ChangeContent2}
          />
        </div>
        <div className={styles.menutext}>A playable website for music</div>
        <Link to="/introduction" className={styles.link}>
          <div>Introduction</div>
        </Link>
        <Link to="/games" className={styles.link}>
          <div>Games</div>
        </Link>
        <Link to="/story" className={styles.link}>
          <div>Creator's Story</div>
        </Link>
        <div className={styles.speciallink} onClick={ChangeContent2}>
          <img className={styles.listen} src={Music} /> Enjoy the Music
        </div>
      </div>
      <div className={styles.original} id="Original">
        <div className={styles.title}>
          <div className={styles.titletext}>
            Enjoy the Music <img className={styles.listen} src={Music} />{" "}
          </div>
          <img src={Menu} className={styles.img} onClick={ChangeContent1} />
        </div>
        <SongList
          title="Aegleseeker"
          artist="ARTIST: Silentroom/Frums   /   BPM: 117   /   DATE: 2021.05.27"
          song={Aegleseeker}
        />
        <SongList
          title="Dantalion"
          artist="ARTIST: Team Grimoire   /   BPM: 186   /   DATE: 2021.10.30"
          song={Dantalion}
        />
        <SongList
          title="烈華RESONANCE"
          artist="ARTIST: REDALiCE/Kobaryo   /   BPM: 120   /   DATE: 2021.07.01"
          song={烈華}
        />
        <SongList
          title="Ringed Genesis"
          artist="ARTIST: Edelritter   /   BPM: 160   /   DATE: 2020.10.26"
          song={RingedGenesis}
        />
        <SongList
          title="Igallta"
          artist="ARTIST: Se-U-Ra   /   BPM: 230   /   DATE: 2020.08.31"
          song={Igallta}
        />
        <SongList
          title="望影の方舟Six"
          artist="ARTIST: Se-U-Ra   /   BPM: 210   /   DATE: 2016.10.31"
          song={望影}
        />
        <SongList
          title="Liberation"
          artist="ARTIST: Silaver/lixound   /   BPM: 150-195   /   DATE: 2019.11.10"
          song={Liberation}
        />
        <SongList
          title="初音ミクの消失"
          artist="ARTIST: 初音未来/石川綾子   /   BPM: 120   /   DATE: 2014.12.10"
          song={初音}
        />
        <SongList
          title="CHAOS"
          artist="ARTIST: Æsir   /   BPM: 150   /   DATE: 2018.03.09"
          song={CHAOS}
        />
        <SongList
          title="Marigold"
          artist="ARTIST: M2U/Guriri   /   BPM: 160   /   DATE: 2017.08.25"
          song={Marigold}
        />
      </div>
    </div>
  );
}

export default Introduction;
